module.exports = global["$"] = require("-!D:\\Sites\\html.xively.com\\node_modules\\jquery\\dist\\jquery.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/expose-loader?$!./~/jquery/dist/jquery.js
 ** module id = 2
 ** module chunks = 0
 **/